import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Validators, FormControl } from '@angular/forms';
import { HttpService } from '../../../services/http/http.service';
import { LocalstorageService } from '../../../services/localstorage/localstorage.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { MatSnackBar } from '@angular/material';
import { PlatformLocation } from '@angular/common';

@Component({
  selector: 'app-more-info',
  templateUrl: './more-info.component.html',
  styleUrls: ['./more-info.component.scss']
})
export class MoreInfoComponent implements OnInit {
  nameExp = '[a-zA-Z ]*$';
  digitExp = '^[0-9]*$';
  graduationYear = [];
  currentQualification = "BE";
  currentYear = new Date().getFullYear();
  isDataToBeStoredInCodingClub:any
  isDataToBeStoredInCodingCafe:any;
  constructor(private router: Router,
    private httpService: HttpService,
    private localstorageService: LocalstorageService,
    private spinnerService: Ng4LoadingSpinnerService,
    private snackbar: MatSnackBar,
    location1: PlatformLocation) {
    location1.onPopState(() => {
      
      window.history.go(1);
    
      return false;

    });
  }
  qualificationArray = ['BE', 'ME', 'MCA', 'BTECH', 'MTECH', 'MSC', 'Others'];
  qualification = new FormControl(null, [Validators.required, Validators.pattern(this.nameExp), this.noWhitespaceValidator]);
  year = new FormControl(null, [Validators.required, Validators.pattern(this.digitExp)]);
  currentPincode = new FormControl(null, [Validators.required, Validators.pattern(this.digitExp),Validators.minLength(6),Validators.maxLength(6), this.noWhitespaceValidator]);
  permanentPincode = new FormControl(null, [Validators.required, Validators.pattern(this.digitExp),Validators.minLength(6),Validators.maxLength(6), this.noWhitespaceValidator]);
 
  ngOnInit() {
   this.isDataToBeStoredInCodingClub =localStorage.getItem('isDataToBeStoredInCodingClub')
   this.isDataToBeStoredInCodingCafe=localStorage.getItem('isDataToBeStoredInCodingCafe')
  
    history.pushState(null, null, location.href);

    for (var i = 2011; i <= this.currentYear+4; i++) {
      this.graduationYear.push(i);
    }
  }


  goToResult() {
    if (this.qualification.value && this.year.value && this.currentPincode.value !== undefined) {
      this.router.navigate(['ccresult']);
    }
  }

  getErrorForYear() {
    return this.year.hasError('required') ? 'Year cannot be blank' :
      this.year.hasError('pattern') ? 'Year cannot contains alphabet' : '';
  }

  getErrorForqualification() {
    return this.qualification.hasError('required') ? 'Qualification Cannot be blank' :
      this.qualification.hasError('pattern') ? 'Qualification must contains alphabet only' :
        this.qualification.hasError('whitespace') ? 'Please provide valid full name' :
          '';
  }
  getErrorForCurrentPincode() {
    return this.currentPincode.hasError('required') ? 'Current pincode Cannot be blank' :
      this.currentPincode.hasError('pattern') ? 'Please provide valid pincode' :
        this.currentPincode.hasError('whitespace') ? 'Please provide valid pincode' :
        this.currentPincode.hasError('maxlength') ? 'Pincode should be max 6 digit' :
        this.currentPincode.hasError('minlength') ? 'Pincode should be min 6 digit' :
          '';
  }
  getErrorForPermanentPincode() {
    return this.permanentPincode.hasError('required') ? 'Permanent pincode Cannot be blank' :
      this.permanentPincode.hasError('pattern') ? 'Please provide valid pincode' :
        this.permanentPincode.hasError('whitespace') ? 'Please provide valid pincode' :
        this.permanentPincode.hasError('maxlength') ? 'Pincode should be max 6 digit' :
        this.permanentPincode.hasError('minlength') ? 'Pincode should be min 6 digit' :
          '';
  }
  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

 
  updateUserDetails() {
    var data = {
      graduationYear: this.currentYear,
      currentPinCode: this.currentPincode.value,
      permanentPinCode: this.permanentPincode.value,
      qualification: this.currentQualification == 'Others' ? this.qualification.value : this.currentQualification,
      dataToBeStoredInCodinClub:this.isDataToBeStoredInCodingClub,
      dataToBeStoredInCodingCafe:this.isDataToBeStoredInCodingCafe
    }

 

    let userId = this.localstorageService.getData('userId');
    this.spinnerService.show();
    var contentBody = { url: "/mcq/users/updateinformation", body: data }
 
    
    this.httpService.putWithTokens(contentBody, true).subscribe(response => {
     

      this.localstorageService.setData("location", this.currentPincode.value);
      
      this.spinnerService.hide();
     // this.httpService.redirectTo("/ccresult");

    }, error => {
     
      this.spinnerService.hide();
      this.openSnackBar(error.error.message);
    })
  }
  setValue(setData) {
    if (setData == 'currentPincode') {
      this.currentPincode.setValue(this.currentPincode.value.trim());
    }
    else if (setData == 'permanentPincode') {
      this.permanentPincode.setValue(this.permanentPincode.value.trim());
    }
    else {
      if (this.currentQualification == 'Others') {
        this.qualification.setValue(this.qualification.value.trim())
      }
    }
  }

  openSnackBar(message: string) {
    if (message === null) {
      this.snackbar.open("Network Error", null, {
        duration: 5000
      });
    }
    else {
      this.snackbar.open(message, null, {
        duration: 5000
      });
    }
  }

 

}
